import styled from 'theme';

export const ContentBackground = styled('div')`
  position: relative;
  width: 100%;
  background-color: var(--ref-color-gray-10);
  flex: auto;
`;
